"use client";

import type { FormEvent } from "react";
import { GlassIconButton } from "../buttons/GlassIconButton";
import { ArtistIcon } from "../icons/ArtistIcon";

export interface MessageInputBarProps {
	readonly value: string;
	readonly onChange: (value: string) => void;
	readonly onSend: () => void;
	readonly label: string;
	readonly disabled?: boolean;
	readonly className?: string;
}

/**
 * MessageInputBar — sticky message composer with a textarea and send button.
 * Mirrors the DS message input primitive.
 */
export function MessageInputBar({
	value,
	onChange,
	onSend,
	label,
	disabled = false,
	className = "",
}: Readonly<MessageInputBarProps>) {
	return (
		<form
			className={`ds-message-input ${className}`.trim()}
			onSubmit={(event: FormEvent<HTMLFormElement>) => {
				event.preventDefault();
				onSend();
			}}
		>
			<textarea
				aria-label={label}
				value={value}
				onChange={(event) => onChange(event.currentTarget.value)}
				rows={1}
			/>
			<GlassIconButton label="发送" type="submit" disabled={disabled}>
				<ArtistIcon name="send" />
			</GlassIconButton>
		</form>
	);
}
